import { ModuleWithProviders, NgModule, Optional, SkipSelf } from "@angular/core";
import { OpenIdAuthModule } from "./openidauth.module";
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule]
})

export class IdentityModule {
    constructor(@Optional() @SkipSelf() parentModule?: IdentityModule) {
        if (parentModule) {
            throw new Error(
                'IdentityModule is already loaded.');
        }
    }

    static forRoot(configService: AuthConfig): ModuleWithProviders<IdentityModule> {
        return {
            ngModule: configService.isOpenId ? OpenIdAuthModule : IdentityModule,
            providers: [{provide: AuthConfig, useValue: configService}]
        }
    }
}

export class AuthConfig {
    isOpenId : any
}